import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import * as Icons from '@material-ui/icons';
import { api } from '../service/api';
import { SnackbarProvider, VariantType, useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.datafort.com.br/">
        Datafort Tecnologia
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

function MyApp() {
  const classes = useStyles();
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const sendMsg = (msg: string, variant: VariantType) => {
    enqueueSnackbar(msg, { variant });
  };

  const fnLogin = async (e:any) =>{
    e.preventDefault();

    const data = {
      "email": email,
      "password": password,
      "forced": true
    }

    try {
      let sResponse = await api.post('auth',data);      
      sendMsg('Teste de sucesso', 'success');

      const sUser = JSON.parse(JSON.stringify(sResponse.data));
  
      sessionStorage.setItem('userId',sUser.id);
      sessionStorage.setItem('userEmail',sUser.email);
      sessionStorage.setItem('userName',sUser.name);
      sessionStorage.setItem('userToken',sUser.token);
      // sessionStorage.setItem('userData',JSON.stringify(sUser));
      history.push('./dashboard');

    } catch (error) {
      console.log(error);
      sendMsg('Usuário ou senha inválidos!', 'error');
    }
    

  }
  


  return (
    <React.Fragment>
      <form className={classes.form} onSubmit={fnLogin}>
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="email"
        label="Email"
        name="email"
        type="email"
        autoComplete="email"
        autoFocus
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="password"
        label="Senha"
        type="password"
        id="password"
        autoComplete="current-password"
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
      <FormControlLabel
        control={<Checkbox value="remember" color="primary" />}
        label="Lembre-se"
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        Entrar
      </Button>
      <Grid container>
        <Grid item xs>
          <Link href="#" variant="body2">
            Perdeu sua Senha?
          </Link>
        </Grid>
        <Grid item>
        </Grid>
      </Grid>
      </form>
    </React.Fragment>
  );
}





export default function Logon() {
  const classes = useStyles();
  const history = useHistory();
  const userEmail = sessionStorage.getItem('userEmail');
  const userToken = sessionStorage.getItem('userToken');
  
  if (userEmail && userToken && (userToken.length === 32)) {
      history.push('./dashboard');
  }
  
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <Icons.LockOutlined />
        </Avatar>
        <Typography component="h1" variant="h5">
          Datafort IA - Login
        </Typography>


        <SnackbarProvider maxSnack={3}>
          <MyApp />
        </SnackbarProvider>

      </div>
      <Box mt={8}>
        <Copyright />
      </Box>

    </Container>
  );
}